import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=4637cb9f&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&lang=ts"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=4637cb9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4637cb9f",
  null
  
)

export default component.exports